<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'SlideTransition',
  props: {
    enter: {
      type: String,
      default: 'slideInRight',
    },
    leave: {
      type: String,
      default: 'slideOutLeft',
    },
  },
})
</script>

<template>
  <transition
    :enter-active-class="`animated ${enter}`"
    :leave-active-class="`animated ${leave}`"
  >
    <slot />
  </transition>
</template>
